<template>
  <v-container class="" fluid>
    <v-row no-gutters class="mx-md-2 px-md-2 mx-sm-1 px-sm-1 ">
      <div class=" text-center flex justify-center align-center text-xl font-Handel h-[calc(100vh-150px)] bg-black rounded-3xl  animate-pulse	">
        <div>
          No {{ type }} selected
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "",
      required: true,
    },
  },
};
</script>
